import { alpha } from "@mui/system";

const styles = (theme) => ({
	cardSubText: {
		fontWeight: 600,
		fontSize: "16px",

		mb: 0.4,
		"@media (max-width: 600px)": {
			fontSize: "16px",
			mb: 0.1,
		},
	},
	containerComponent: {
		display: "flex",
		flexDirection: "column",
		gap: 1,
		width: "100%",
	},
	linearProgressLoading: {
		position: "absolute",
		top: 0,
		left: 0,
		width: "100%",
		zIndex: 1,
	},
	paper: {
		padding: "16px",
		display: "flex",
		flexDirection: "row",
		gap: 1,
		justifyContent: "space-between",
		maxHeight: "200px",
		width: "100%",
		maxWidth: "100%",
		borderRadius: "16px",
		position: "relative",
		overflow: "hidden",
	},
	containerCardData: {
		width: "265px",

		display: "flex",
		flexDirection: "column",
		margin: "15px 0 0 0",
		height: "200px",
	},
	containerCardDataTitle: {
		width: "100%",
		borderRadius: "10px 10px 0 0",
		display: "flex",
		flexDirection: "column",
		justifyContent: "left",
		alignItems: "center",
		gap: 1,
		margin: "0 0 5px 0",
	},
	containerIcon: {
		borderRadius: "5px",
		width: "30px",
		height: "30px",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		backgroundColor: theme.palette.colors.green.lighter,
	},
	cardTitle: {
		fontSize: "20px",
		fontWeight: "bold",
		color: theme.palette.colors.green.lighter,
	},

	containerTooltip: {
		display: "flex",

		alignItems: "center",
		gap: 1,
	},
	textTooltip: {
		fontWeight: "bold",
		fontSize: "15px",
		textTransform: "capitalize",
	},
	paperDatagrid: {
		width: "100%",
		overflowX: "auto",
		backgroundColor: theme.palette.background.paper,
		borderRadius: "16px",
		marginTop: "20px",
		maxHeight: "150px",
	},
	boxValueTooltip: {
		width: 8,
		height: 8,
		borderRadius: 8,
	},
	boxContainerTooltip: {
		bgcolor: theme.palette.paletteCharts.lineCharts,
		padding: "8px",
		borderRadius: "8px",
	},
	textInfoTooltip: {
		fontSize: "12px",
		fontStyle: "italic",
		color: "#aaa",
		marginTop: "4px",
	},
	containerUsage: {
		display: "flex",
		alignItems: "center",
		width: "100%",
		gap: 1,
		minWidth: 0,
	},
	linearProgress: {
		width: "90%",
		height: 10,
		borderRadius: 5,
		backgroundColor: theme.palette.colors.gray.lighter,
	},
	textUsage: {
		fontSize: "0.75rem",
		fontWeight: 500,

		minWidth: "32px",
	},
	containerGrid: {
		display: "flex",
		flexDirection: "row",
		width: "100%",
	},
	iconButton: {
		width: 40,
		height: 40,
		borderRadius: 1,
		border:
			theme.palette.mode === "dark"
				? `1px solid ${theme.palette.white.main}33`
				: `1px solid ${theme.palette.black.main}40`,
		color: "white",
		bgcolor: "transparent",
		"&:hover": {
			// bgcolor:
			// 	theme.palette.mode === "dark"
			// 		? `${theme.palette.white.main}33`
			// 		: `${theme.palette.black.main}15`,
			border:
				theme.palette.mode === "dark"
					? `1px solid ${theme.palette.white.main}`
					: `1px solid ${theme.palette.black.main}`,
		},
	},
	boxTopContent: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		mb: 2,
	},
	containerTooltipDonut: {
		padding: 1,
		backgroundColor: alpha(theme.palette.paletteCharts.lineCharts, 0.9),
		borderRadius: 1,
	},
	containerCard: {
		height: "100%",
	},
});

export default styles;
